import URLConst from '../constants/URLConst';
import { fetchJSON, securePUT } from '../utilities/FetchHelper';

class MultiUserEndpointService {

    acquireUser(data) {
        let url = URLConst.HOTEL_ONBOARDING_SERVICE + URLConst.PATH_ACQUIRE_USER
        for (const key in data) {
            url = url.replace('{' + key + '}', data[key])
        }

        return fetchJSON(url, { ...securePUT(), body: JSON.stringify({}) }).then(response => {
            return response
        }).catch((error) => {
            throw error
        })
    }

    resetUser(data) {
        let url = URLConst.HOTEL_ONBOARDING_SERVICE + URLConst.PATH_RESET_USER
        for (const key in data) {
            url = url.replace('{' + key + '}', data[key])
        }

        return fetchJSON(url, { ...securePUT(), body: JSON.stringify({}) }).then(response => {
            return response
        }).catch((error) => {
            throw error
        })
    }

}

export default new MultiUserEndpointService();